import { IApiResult } from "auth/interface/api.interface"

export interface CreateTemplateModalProps {
  open: boolean
  onClose: () => void
  onComplete: (data: TemplateFormData) => void
  checkTemplate?: any // The template to edit, undefined for creating new
  checkTemplateResult: IApiResult
  checkTemplateListResult: IApiResult
}

export interface Vehicle {
  id: number
  regNumber: string
  internnumber: string
  brand: string
  model: string
  inspectionData?: VehicleInspectionData
}

export interface VehicleInspectionData {
  lastInspectionDate?: Date | null
  inspectionDeadline?: Date | null
  meterReading?: number
}

export interface VehicleGroup {
  id: number
  name: string
  vehicleIds: number[]
  vehicleCount?: number
  vehiclesInfo?: VehicleBasicInfo[]
}

export interface VehicleBasicInfo {
  id: number
  regNumber: string
  internnumber?: string
}

export enum OdometerDataSource {
  IoTDevice = 0,
  ManualEntry = 1,
  None = 2
}

export interface IoTOdometerStatus {
  hasIoTDevice: boolean
  ioTOdometer?: number | null
  ioTLastUpdated?: Date | null
  isIoTDataRecent: boolean
  manualOdometer?: number | null
  manualLastUpdated?: Date | null
  currentOdometer?: number | null
  dataSource: OdometerDataSource
  lastUpdated?: Date | null
  isDataRecent: boolean
}

export interface TemplateFormData {
  id?: number // Optional id for editing existing templates
  name: string
  usesDate: boolean
  usesDistance: boolean
  usesInspection: boolean
  dateInterval: number
  distanceInterval: number
  dateCalculationType: 'Dynamic' | 'Static'
  distanceCalculationType: 'Dynamic' | 'Static'
  selectedVehicles: number[]
  vehicleLastValues: {
    [vehicleId: number]: {
      lastDate?: Date | null
      lastDistance?: number
      inspectionData?: VehicleInspectionData
    }
  }
}
